(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-banner-drag"] && !Shopify.designMode) return;
  try {
    
class DragContent extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.isMobile = window.matchMedia('(max-width: 767px)');
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.drag-item'));
    if (!this.items.length) return;

    this.initItemsToCenter();
    window.addEventListener('resize', this.onResize);

    this.items.forEach((item) => {
      this.attachHoverEffects(item);
      this.attachDragHandlers(item);
    });

    requestAnimationFrame(() => {
      this.animateItemsToTarget();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.animateItemsToTarget();
  }

  getContainerRect() {
    const wrapper = this.closest('.ab_wrapper') || this;
    return wrapper.getBoundingClientRect();
  }

  initItemsToCenter() {
    this.items.forEach((item) => {
      item.style.left = '50%';
      item.style.top = '50%';
    });
  }

  animateItemsToTarget() {
    const rect = this.getContainerRect();
    if (!rect.width || !rect.height) return;

    const useMobile = this.isMobile.matches;

    this.items.forEach((item) => {
      const desktopX = this.parseNumber(item.dataset.desktopX, 50);
      const desktopY = this.parseNumber(item.dataset.desktopY, 50);
      const mobileX = this.parseNumber(item.dataset.mobileX, desktopX);
      const mobileY = this.parseNumber(item.dataset.mobileY, desktopY);

      const targetX = useMobile ? mobileX : desktopX;
      const targetY = useMobile ? mobileY : desktopY;

      item.style.left = targetX + '%';
      item.style.top = targetY + '%';
    });
  }

  parseNumber(value, fallback) {
    if (value == null || value === '') return fallback;
    const n = Number(value);
    if (Number.isNaN(n)) return fallback;
    return n;
  }

  attachHoverEffects(item) {
    item.addEventListener('mouseenter', () => {
      const extra = this.randomAngle();
      item.style.setProperty('--rotate-extra', extra + 'deg');
    });

    item.addEventListener('mouseleave', () => {
      item.style.setProperty('--rotate-extra', '0deg');
    });
  }

  randomAngle() {
    const min = 15;
    const max = 30;
    const angle = Math.random() * (max - min) + min;
    const sign = Math.random() > 0.5 ? 1 : -1;
    return angle * sign;
  }

  attachDragHandlers(item) {
    let dragging = false;
    let pointerId = null;

    const getRect = () => this.getContainerRect();

    const onPointerDown = (event) => {
      event.preventDefault();
      dragging = true;
      pointerId = event.pointerId;
      item.setPointerCapture(pointerId);

      item.classList.add('drag-item--dragging');

      const maxZ = this.getMaxZIndex();
      item.style.zIndex = String(maxZ + 1);
    };

    const onPointerMove = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;

      const rect = getRect();
      if (!rect.width || !rect.height) return;

      const relX = event.clientX - rect.left;
      const relY = event.clientY - rect.top;

      let leftPercent = (relX / rect.width) * 100;
      let topPercent = (relY / rect.height) * 100;

      leftPercent = Math.max(0, Math.min(100, leftPercent));
      topPercent = Math.max(0, Math.min(100, topPercent));

      item.style.left = leftPercent + '%';
      item.style.top = topPercent + '%';
    };

    const onPointerUp = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      item.releasePointerCapture(pointerId);
      pointerId = null;

      item.classList.remove('drag-item--dragging');

      const rect = getRect();
      const itemRect = item.getBoundingClientRect();

      const centerX = itemRect.left - rect.left + itemRect.width / 2;
      const centerY = itemRect.top - rect.top + itemRect.height / 2;

      let leftPercent = (centerX / rect.width) * 100;
      let topPercent = (centerY / rect.height) * 100;

      leftPercent = Math.max(0, Math.min(100, leftPercent));
      topPercent = Math.max(0, Math.min(100, topPercent));

      const useMobile = this.isMobile.matches;
      if (useMobile) {
        item.dataset.mobileX = String(leftPercent);
        item.dataset.mobileY = String(topPercent);
      } else {
        item.dataset.desktopX = String(leftPercent);
        item.dataset.desktopY = String(topPercent);
      }
    };

    item.addEventListener('pointerdown', onPointerDown);
    item.addEventListener('pointermove', onPointerMove);
    item.addEventListener('pointerup', onPointerUp);
    item.addEventListener('pointercancel', onPointerUp);
    item.addEventListener('pointerleave', (event) => {
      if (dragging) onPointerUp(event);
    });
  }

  getMaxZIndex() {
    let max = 0;
    this.items.forEach((item) => {
      const z = parseInt(window.getComputedStyle(item).zIndex || '0', 10);
      if (z > max) max = z;
    });
    return max;
  }
}

if (!customElements.get('drag-content')) {
  customElements.define('drag-content', DragContent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
